import { Center, Tooltip } from '@mantine/core';
import { IconPencilOff } from '@tabler/icons-react';

interface NotEditableProps {
  tooltip: string;
}

export function NotEditable({ tooltip }: NotEditableProps) {
  return (
    <Tooltip label={tooltip}>
      <Center>
        <IconPencilOff size="25px" />
      </Center>
    </Tooltip>
  );
}
